<template>
  <path d="M735.578585 69.309046c-87.370831 0-169.314462 42.669292-223.578585 114.049969-54.272-71.3728-136.215631-114.049969-223.586462-114.049969C129.386338 69.309046 0 208.139815 0 378.7776c0 280.670523 310.791877 471.441723 444.416 540.427815a148.220062 148.220062 0 0 0 68.017231 16.478523c23.071508 0 46.135138-5.356308 67.182277-16.068923C713.231754 851.637169 1024 662.850954 1024 378.7776c0-170.637785-129.386338-309.468554-288.421415-309.468554z"></path>
</template>

<script>

  export default {
    name: "icon-love"
  }
</script>

<style scoped>

</style>
